import "./Socilamedia.css";

const Socialmedia = () => {
  return (
    <>
      <ul className="example-2">
        <li className="icon-content">
          <a href="https://www.linkedin.com/company/vensap/?viewAsMember=true" aria-label="LinkedIn" data-social="linkedin">
            <div className="filled"></div>
            <i className="bi bi-linkedin z-4"></i>
          </a>
          <div className="tooltip">LinkedIn</div>
        </li>
        <li className="icon-content">
          <a
            href="https://www.github.com/"
            aria-label="GitHub"
            data-social="github"
          >
            <div className="filled"></div>
            <i className="bi bi-twitter-x"></i>
          </a>
          <div className="tooltip">Twitter</div>
        </li>
        <li className="icon-content">
          <a
            href="https://www.instagram.com/vensapinfo?igsh=MTV5NnZnMTd3OHZybQ=="
            aria-label="Instagram"
            data-social="instagram"
          >
            <div className="filled"></div>
            <i className="bi bi-instagram"></i>
          </a>
          <div className="tooltip">Instagram</div>
        </li>
        <li className="icon-content">
          <a
            href="https://youtube.com/"
            aria-label="Youtube"
            data-social="youtube"
          >
            <div className="filled"></div>
            <i className="bi bi-whatsapp"></i>
          </a>
          <div className="tooltip">WhatsApp</div>
        </li>
      </ul>
    </>
  );
};
export default Socialmedia;
